import React from 'react';
import Button, { ButtonModeE } from '../../components/Button/Button';
import usePopup from '../../utils/hooks/usePopup';

import styles from './styles.module.scss';

const WaitForEncodingFooter = () => {
    const { removePopup } = usePopup();

    return (
        <div className={styles.footer}>
            <Button onClick={removePopup} mode={ButtonModeE.OUTLINED}>Close</Button>
        </div>
    );
};

export default WaitForEncodingFooter;